import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	width: 100%;
	padding: var(--inputPadding);

	&.custom-disabled-field {
		padding: 0;
		height: 4.5rem;
		min-height: 4.5rem;
		align-items: center;

		body[dir='rtl'] & {
			height: 5.5rem;
			min-height: 5.5rem;
		}

		.typography {
			color: var(--content-4) !important;
		}
	}

	background-color: var(--input-disabled-bg-color);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	min-height: 4.5rem;

	body[dir='rtl'] & {
		min-height: 5.5rem;
	}
`;
